import { A11yModule } from "@angular/cdk/a11y";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatRippleModule, MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { MonedaDirective } from "@directives/moneda.directive";
import { BaseDto } from "@models/base/baseDto.model";
import { DtoBase } from "@models/base/dtoBase.model";
import { AccionesDialog } from "@models/base/identificadores.model";
import { CuentaCajaDto } from "@models/cuentaCaja/cuentaCajaDto.model";
import { CuentaContableDto } from "@models/cuentaContable/cuentaContableDto.model";
import { EmpresaUsuarioDto } from "@models/empresaUsuario/empresaUsuarioDto.model";
import { ExpedienteSummaryDto } from "@models/expediente/expedienteSummary.model";
import { CreateTareaRequest } from "@models/tarea/createTareaRequest.model";
import { TareaDto } from "@models/tarea/tareaDto.model";
import { UpdateTareaRequest } from "@models/tarea/updateTareaRequest.model";
import { EmpresaUsuarioService } from "@services/empresaUsuario/empresaUsuario.service";
import { EstadoTareaService } from "@services/estadoTarea/estadoTarea.service";
import { LoginService } from "@services/login/login.service";
import { SnackBarService } from "@services/snackBar/snack-bar-service.service";
import { TareaService } from "@services/tarea/tarea.service";
import { TiposTareaService } from "@services/tipoTarea/tipoTarea.service";
import { BuscarExpedienteComponent } from "@views/busquedas/buscar-expediente/buscar-expediente.component";
import { NgxMaskDirective } from "ngx-mask";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ButtonAddComponent } from "src/app/component/button-add/button-add.component";
import { ButtonCancelDialogComponent } from "src/app/component/button-cancel-dialog/button-cancel-dialog.component";
import { ButtonCloseDialogComponent } from "src/app/component/button-close-dialog/button-close-dialog.component";
import { ButtonDeleteComponent } from "src/app/component/button-delete/button-delete.component";
import { ButtonSaveComponent } from "src/app/component/button-save/button-save.component";
import { SelectUsuariosEmpresaComponent } from "src/app/component/select-usuarios-empresa/select-usuarios-empresa.component";
import { DialogFormTareaComponent } from "../dialog-form-tarea/dialog-form-tarea.component";
import { MatGridListModule } from "@angular/material/grid-list";


@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, MonedaDirective, SelectUsuariosEmpresaComponent,MatGridListModule],
  templateUrl: `form-view-tarea.component.html`,
  styleUrl: './form-view-tarea.component.css',
  providers: [
  { provide: MatDialogRef, useValue: {} },
  { provide: MAT_DIALOG_DATA, useValue: {} }
]

})


export class FormViewTareaComponent {

  lstNiveles: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];

  lstPrioridades: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];
  estadosTarea!: BaseDto[];
  tarea!: TareaDto;
  tiposTarea!: BaseDto[];
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;

  formBuilder: FormBuilder = new FormBuilder;

  constructor(
    public dialogRef: MatDialogRef<DialogFormTareaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private tipoTareaService: TiposTareaService,
    private tareaService: TareaService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private estadoTareaService: EstadoTareaService,

  ) {

    this.getAllTiposTarea()
    this.getAllEstadosTarea()
  }

  ngOnInit(): void {

    this.tarea = this.data?.item || {};
    this.setForm();
  }
  onUsuarioSeleccionado(usuario: any) {
    this.form.get('AprobadoPor')?.setValue(usuario.id);
  }

  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  getAllTiposTarea() {
    this.spinner.show("spTipoTarea")
    this.tipoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoTarea")
          this.tiposTarea = data
        },
        error => {
          this.spinner.hide("spTipoTarea")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosTarea() {
    this.spinner.show('spEstadosTarea')
    this.estadoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosTarea')
          this.estadosTarea = data
        },
        error => {
          this.spinner.hide('spEstadosTarea')
          this.snackBar.showError(error, "Error");
        })
  }
  setForm(): void {
    this.form = this.formBuilder.group({
      Id: [this.tarea?.id || null],
      Descripcion: [this.tarea?.descripcion || '', Validators.compose([Validators.maxLength(200)])],
      Observaciones: [this.tarea?.observaciones || '', Validators.compose([Validators.maxLength(500)])],
      FechaVencimiento: [this.tarea?.fechaVencimiento || null,],
      IdEstadoTarea: [this.tarea?.estadoTarea?.id || null],
      IdTipoTarea: [this.tarea?.tipoTarea?.id || null],
      IdExpediente: [this.tarea?.expediente?.id || null],
      Notificado: [this.tarea?.notificado || null],
      FechaInicioReal: [this.tarea?.fechaInicioReal || null],
      FechaInicioEstimada: [this.tarea?.fechaInicioEstimada || null],
      AutorizadoPor: [this.tarea?.autorizadoPor?.id || null],
      AsignadoA: [this.tarea?.asignadoA?.id || null],
      IdTareaPadre: [this.tarea?.tareaPadre?.id || null],
      NivelAvance: [this.tarea?.nivelAvance || null],
      Titulo: [this.tarea?.titulo || null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      Prioridad: [this.tarea?.prioridad || null],
    });
  }

  trackByItems(index: number, item: any): any { return item; }
}


